<template>

  <div class="background">

		<!-- Header -->
		<div>
			<div class="py-2 text-center text-white small-info-box"><i class="fa fa-phone"></i> &nbsp; <a class="text-white t-deco-none" href="tel:03020059077520">030 / 200 590 77 520</a> - kostenfreie Soforthilfe</div>
		</div>
    <div class="container">
      <div class="row">
        <div class="col-12 text-center pt-4">
					<div class="mb-3 text-shadow text-white">
						<p class="font-weight-bold m-0 p-0 pb-sm-0 pb-2 font-2em line-height-sm" style="">Sind auch Sie vom Abgasskandal betroffen?</p>
						<p class="text-shadow font-1-7em" style="">Jetzt kostenlose Erstberatung anfordern.</p>
					</div>
        </div>
      </div>
    </div>


    <div class="container p-0 bg-white mt-3 mb-3 border-radius">
			<!-- Frage -->
			<div class="p-2 p-lg-4">
				<div v-if="schritt <= fragen.length">
					<h3 class="text-bold font-1-7em text-center p-0 m-0">
						{{ fragen[schritt - 1].frage }}
					</h3>
				</div>

				<div v-if="schritt > fragen.length && !finished">
					<h3 class="bold-600 text-center p-0 m-0">Sie sind fast fertig!</h3>
					<p class="lead font-weight-light text-center p-0 m-0">Für Ihr <span class="bold-600">kostenloses Prüfungsergebnis</span> benötigen wir noch:</p>
				</div>

			</div>



			<div class="bg-light px-4 pt-1 pb-4" style="box-shadow: 0 0 20px rgba(0, 0, 0, 0.1)" v-if="!finished">
				<!-- Fragenkatalog -->
				<div v-if="schritt <= fragen.length">

					<!-- Antworten -->
					<b-row class="mt-4">
						<b-col :lg="antwortCols[fragen[schritt - 1].antworten.length]" v-for="antwort in fragen[schritt - 1].antworten" :key="antwort.text">
							<div :class="{'blinker text-white': $data[fragen[schritt - 1].dataName] === antwort.value}" class="antwort text-center" @click=" nextStep($data[fragen[schritt - 1].dataName],antwort.value); sendGaEvent(fragen[schritt - 1].frage)">

								<div class="d-flex d-lg-none align-items-center">
									<div style="width:40px; margin-right:10px; font-size:1em">
										<img height="38" :src="require('@/assets/img/icons/'+antwort.icon)" :style="antwort.mobileStyle" class="mr-2" />
									</div>
									<span style="font-size:18px">
										{{ antwort.text }}
									</span>
								</div>

								<div class="d-none d-lg-block text-center">
									<img height="80" :src="require('@/assets/img/icons/'+antwort.icon)" class="" />
									<div class="mt-3">{{ antwort.text }}</div>
								</div>

							</div>
						</b-col>
					</b-row>

					<!-- Buttons -->
					<b-row class="mt-4">
						<b-col lg="12">
							<div class="text-left">
								<b-button v-if="schritt > 1" variant="light" class="text-secondary" @click="prevStep()">
									<i class="fa fa-caret-left" aria-hidden="true"></i> Zurück
								</b-button>
							</div>
						</b-col>
					</b-row>
				</div>

				<div v-else>
					<b-row>
						<b-col lg="12" class="mt-3">

							<form id="form_4">
								<b-row>
									<b-col size="12" md="6">
										<b-form-group>
											<b-form-radio-group @change="sendGaEvent('Anrede')" v-model="stammdaten.anrede" required id="anrede">
												<b-form-radio value="Herr">Herr</b-form-radio>
												<b-form-radio value="Frau">Frau</b-form-radio>
											</b-form-radio-group>
										</b-form-group>
									</b-col>
								</b-row>

								<b-row>
									<b-col size="12" md="6">
										<b-form-group>
											<label class="">Ihr Vorname</label>
											<b-input @change="sendGaEvent('Ihr Vorname')" name="vorname" autocomplete="fname" placeholder="Vorname" v-model="stammdaten.vorname" required></b-input>
										</b-form-group>
									</b-col>

									<b-col size="12" md="6">
										<b-form-group>
											<label class="">Ihr Nachname</label>
											<b-input @change="sendGaEvent('Ihr Nachname')" name="nachname" autocomplete="lname" placeholder="Nachname" v-model="stammdaten.nachname" required></b-input>
										</b-form-group>
									</b-col>
								</b-row>

								<b-row>
									<b-col size="12" md="6">
										<b-form-group>
											<label class="">Ihre E-Mail-Adresse</label>
											<b-input @change="sendGaEvent('Ihre E-Mail-Adresse')" name="email" autocomplete="email" type="email" v-model="stammdaten.email" placeholder="E-Mail-Adresse" required></b-input>
										</b-form-group>
									</b-col>

									<b-col size="12" md="6">
										<b-form-group>
											<label class="">Ihre Telefonnummer</label>
											<b-input @change="sendGaEvent('Ihre Telefonnummer')" name="telefonnummer" autocomplete="phone" placeholder="Telefonnummer" v-model="stammdaten.telefon" required></b-input>
										</b-form-group>
									</b-col>
								</b-row>

								<!-- Erstberatung anfordern -->
								<div class="text-center mt-lg-5 mb-lg-3 mt-1 mb-0">
									<b-button
										v-if="!submitting"
										@click.prevent="erstberatungAnfordern()"
										type="submit"
										class="shadow"
										variant="success">
										<i class="fa fa-paper-plane d-none d-md-inline-block"></i> &nbsp; Kostenlose Erstberatung anfordern
									</b-button>
									<b-button v-else variant="success" disabled>
										<b-spinner small></b-spinner> Bitte warten
										<span class="sr-only">Bitte warten ...</span>
									</b-button>
								</div>

							</form>
							<b-row>
                <b-col size="6">
									<div class="mt-4 mt-lg-2 small">
									</div>
								</b-col>
								<b-col size="6">
									<div class="mt-4 mt-lg-2 text-right mobile-sm-text-center small">
										Strenger Datenschutz - gewährleistet durch:<br class="d-inline-block d-md-none" />
										<img class="datenschutz-logo" src="https://www.rueden.de/images/datenschutzbeauftragte_logo_300px.png" alt="Datenschutzbeauftragte Logo" />
									</div>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</div>
			</div>

			<div class="bg-light p-4 text-center" style="box-shadow: 0 0 20px rgba(0, 0, 0, 0.1)" v-else>
				<i v-if="!error" class="fa fa-check-circle text-success fa-3x" aria-hidden="true"></i>
        <i v-if="error" class="fa fa-3x text-danger fa-exclamation-triangle" aria-hidden="true"></i>
        <h4 v-if="error">Es tut uns leid!</h4>
        <h4 v-else>Vielen Dank für Ihre kostenlose Anfrage</h4>

        <p v-if="error">Da ist etwas schief gelaufen, bitte versuchen Sie es in 5 Minuten erneut.</p>
        <p v-else>Wir haben Ihre Anfrage erhalten und melden uns zeitnah bei Ihnen.</p>

      </div>

			<!-- Mehr anzeigen -->
			<div v-if="schritt === 1">
				<!--<div class="pl-4 pr-4 pt-4 pb-2">
					<a style="font-size: 16px" type="button" @click.prevent="show_more_marken = !show_more_marken;" name="weitere-Automarken" class="show-more-click">
						<div v-if="!show_more_marken">
							<i class="fa fa-plus"></i>&nbsp; weitere Automarken anzeigen
						</div>
						<div v-else>
							<i class="fa fa-minus"></i>&nbsp; weitere Automarken ausblenden
						</div>
					</a>
				</div>
      -->
				<div class="pr-4 pl-4 pt-2">
					<b-row class="mt-4">
						<b-col :lg="antwortCols[fragen[schritt - 1].weitereAntworten.length]" v-for="weitereAntwort in fragen[schritt - 1].weitereAntworten" :key="weitereAntwort.text">
							<div :class="{'blinker text-white': $data[fragen[schritt - 1].dataName] === weitereAntwort.value}" class="antwort text-center" @click=" nextStep($data[fragen[schritt - 1].dataName],weitereAntwort.value); ">
								<div class="d-flex d-lg-none align-items-center">
									<div style="width:40px; margin-right:10px; font-size:1em">
										<img height="38" :src="require('@/assets/img/icons/'+weitereAntwort.icon)" :style="weitereAntwort.mobileStyle" class="mr-2" />
									</div>
									<span style="font-size:16px">
										{{ weitereAntwort.text }}
									</span>
								</div>

								<div class="d-none d-lg-block text-center">
									<img height="80" :src="require('@/assets/img/icons/'+weitereAntwort.icon)" class="" />
									<div class="mt-3">{{ weitereAntwort.text }}</div>
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>

			<!-- Fortschritt -->
			<div class="p-4" v-if="schritt <= fragen.length">
				<b-progress class="w-100" max="100" height="1.5rem" variant="success">
					<b-progress-bar :value="(schritt * 100) / fragen.length"></b-progress-bar>
				</b-progress>
			</div>
    </div>

    <!-- Footer -->
    <div class="col-12 pb-4">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center text-white">
						<div v-if="schritt > fragen.length && !finished && !submitting" class="mt-3 small">
							Mit dem Absenden der Anfrage erklären Sie sich mit unserer <a class="text-white" href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a> und dem <a class="text-white" href="#" v-b-modal.modal-widerrufsbelehrung>Widerruf</a> einverstanden.
							<!--<div class="text-center mt-2">
								Wir werden beaufsichtigt von:
								<img src="https://www.rueden.de/images/datenschutzbeauftragte_logo_300px.png" height="44" alt="Datenschutzbeauftragte Logo" />
							</div>
						-->
						</div>
						<div class="mt-3">
							<i class="fa fa-lock text-warning" aria-hidden="true"></i> Sicher dank SSL-verschlüsselter Datenübertragung<br />
							<img class="mt-2" height="16" src="https://www.rueden.de/images/Company-name-logotype-inversion.png" alt="VON RUEDEN" />
						</div>
            <div class="mt-3 text-center text-white">
              <a class="text-white" href="#" v-b-modal.modal-impressum>Impressum</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <Datenschutzerklaerung/>
    <Widerrufsbelehrung/>
    <Impressum />

  </div>

</template>
<style>
	.background {
		height: 100%;
		background: url('../../assets/img/gradient-new.jpg');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>
<script>
  import Impressum from "@/views/Impressum";
  const EMAIL_PATTERN = "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])";
  const PHONE_PATTERN = "(\\+)?([\\/() 0-9]){6,}";

	import Datenschutzerklaerung from '@/views/Datenschutzerklaerung';
  import Widerrufsbelehrung from '@/views/Widerrufsbelehrung';
  import General from '@/mixins/general';
  import Abgasskandal from "@/mixins/abgasskandal";

	export default {
    mixins: [General, Abgasskandal],

		components: {Impressum, Datenschutzerklaerung, Widerrufsbelehrung},

		data() {
			return {
        emailPatter: EMAIL_PATTERN,
        telPattern: PHONE_PATTERN,
        gaCat: 'Lead Funnel Abgas 2',
        schritt: 1,
				lastStep: [],
				token: null,
				lockAnswers: false,
				show_more_marken: false,

				automarke:"",
				rsv_bei_kauf_vorhanden:"",
				finanzierungsart:"",

				stammdaten: {
					anrede: "Herr",
					vorname: "",
					nachname: "",
					email: "",
					telefon: "",
					quelle: 'rueden.de abgasskandal onlinecheck', // bisher, WvR-Law.de es wird "Homepage" angezeigt, NEU svsch 06.07.23 rueden.de abgasskandal onlinecheck
					email_id_mail: '104861', // svsch 27.07.23 email soll verschickt werden
				},

				submitting: false,
				finished: false,

				antwortCols: [12,4,6,4,''],

        error: false,

				fragen: [
					{
						frage: "Welche Automarke fahren Sie?",
						dataName: "automarke",
						antworten: [
							{text: "Mercedes-Benz", value: "Mercedes-Benz", icon: "mercedes.png", mobileStyle: "" },
							{text: "Audi", value: "Audi", icon: "audi.png", mobileStyle: "" },
							{text: "Volkswagen", value: "Volkswagen", icon: "vw.png", mobileStyle: "margin-top:-4px" },
							{text: "Porsche", value: "Porsche", icon: "porsche.png", mobileStyle: "" },
              {text: "Skoda", value: "Skoda", icon: "skoda.png", mobileStyle: "" }
						],
						weitereAntworten : [
							{text: "Seat", value: "Seat", icon: "seat.png", mobileStyle: "" },
							{text: "Opel", value: "Opel", icon: "opel.png", mobileStyle: "margin-top:-4px" },
							{text: "BMW", value: "BMW", icon: "bmw.png", mobileStyle: "" },
              {text: "Mini", value: "Mini", icon: "mini.png", mobileStyle: "" },
							{text: "Fiat (Wohnmobil)", value: "Fiat (Wohnmobil)", icon: "fiat.png", mobileStyle: "" },
              {text: "Iveco", value: "Iveco", icon: "iveco.png", mobileStyle: "" }
						],
					},
					{
						frage: "Waren Sie zum Zeitpunkt des Autokaufs rechtsschutzversichert? ",
						dataName: "rsv_bei_kauf_vorhanden",
						antworten: [
							{text: "Ja", value: "Ja", icon: "check.png", mobileStyle: "margin-top:-4px;" },
							{text: "Nein", value: "Nein", icon: "error.png", mobileStyle: "margin-top:-4px;" }
						],
					},
					{
						frage: "Wie haben Sie das Fahrzeug finanziert?",
						dataName: "finanzierungsart",
						antworten: [
							{text: "Barkauf", value: "Voll bezahlt", icon: "car_barkauf.png", mobileStyle: "" },
							{text: "Darlehen", value: "Darlehen", icon: "car_darlehen.png", mobileStyle: "" },
							{text: "Leasing", value: "Leasing", icon: "car_leasing.png", mobileStyle: "" },
							{text: "Mietkauf", value: "Mietkauf", icon: "car_miete.png", mobileStyle: "" }
						],
					},
				],
			}
		},
		mounted() {
			document.title = 'Abgasskandal - Kostenlose Erstberatung';
      this.$global.gaCat = 'Lead Funnel Abgas';
			if (this.$route.query.automarke) {
        this.automarke = this.$route.query.automarke;
        this.schritt = 2;
      }
		},
		methods: {
			nextStep(property, value) {

				if (this.schritt <= this.fragen.length && this.lockAnswers == false) {

					this.lockAnswers=true

					this[this.fragen[this.schritt - 1].dataName] = value;

					var _this = this;

					setTimeout(function() {

						_this.lastStep.push(_this.schritt);
						_this.schritt += 1;
						_this.lockAnswers = false;

					}, 800);
				}

			},
			prevStep() {
				if (this.schritt > 1) {
					this.schritt = this.lastStep[this.lastStep.length - 1];
					this.lastStep.pop();

					/*if (this.show_more_marken === true) {
						this.show_more_marken = true
					}*/
				}
			},
			erstberatungAnfordern() {
				this.submitting = false;
				if ( this.validateFormOld(this.schritt) === true ) {
          this.submitting = true;
          this.error = this.createToDoVorgang(this.$data);
					this.submitting = false;
					this.finished = true
				}
			},
      validateFormOld(step) {
        let form = document.getElementById("form_" + step);
        let isValid = form.checkValidity();
        if (!isValid) form.reportValidity();
        return isValid;
      },
		},
		computed: {

		}
	}
</script>
